<template>
  <div v-loading="loading">
    <div v-if="show == 'false'">
      <div class="page2_head">
        <div style="font-size: 0.12rem; color: #86909c; margin-bottom: 0.12rem">
          认证前请确认已达到认证要求，不符合要求将不予通过认证
        </div>
        <div style="color: #165dff; font-size: 0.14rem">
          <span>1、实名认证</span>&nbsp;&nbsp;&nbsp;&nbsp;
          <span>2、近 28 天内发布公开作品数不少于 1 部</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>3、相关证明材料完备并在有效期内</span>
        </div>
      </div>
      <!-- ref="ruleFormRef" -->
      <!-- :rules="rules" -->
      <el-form style="width: 6.4rem" :model="ruleForm" label-width="110px" class="demo-ruleForm" :size="formSize"
        status-icon label-position="left" ref="ruleFormRef" :rules="rules">
        <el-form-item label="机构名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入机构名称" />
        </el-form-item>

        <el-form-item label="所在地区" prop="provinceId">
          <!-- <el-input v-model="ruleForm.provinceId" placeholder="请选择" /> -->
          <el-cascader ref="areas" :props="props" v-model="ruleForm.provinceId" placeholder="请选择"
            :show-all-levels="false"></el-cascader>
        </el-form-item>

        <el-form-item label="机构行业" prop="industryId">
          <!-- <el-input v-model="ruleForm.industryId" placeholder="请选择" /> -->
          <el-select v-model="ruleForm.industryId" placeholder="请选择">
            <el-option v-for="item in hangyelist" :key="item.id" :label="item.memberClass" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="昵称" prop="name">
					<el-input v-model="ruleForm.name" placeholder="请输入昵称" />
				</el-form-item> -->
        <el-form-item label="营业执照" prop="licenseSrc">
          <!-- <el-upload class="upload-demo" style="margin-right:0.24rem ;" drag action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
					 multiple>
						<el-icon class="el-icon--upload">
							<div style="
							    width: 0.2rem;
							    height: 0.2rem;
							    background: url(data:image/png;base64,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);
							    background-size: 100%;
							    background-repeat: no-repeat;
							  "></div>
						</el-icon>
						<div class="el-upload__text">
							<div style="font-size: 0.14rem;color: #333333;">上传营业执照</div>

						</div>
					</el-upload> -->
          <el-upload class="upload-demo" style="margin-right: 0.24rem" drag :action="upload_showImage" multiple
            :show-file-list="false" :on-success="onSuccessFrontSrc" :limit="1" ref="upload" list-type="text"
            :on-change="handleChange" :on-remove="handleRemove">
            <el-image v-if="ruleForm.licenseSrc" :src="ruleForm.licenseSrc">
            </el-image>
            <div v-else>
              <el-icon class="el-icon--upload">
                <div style="
                    width: 1rem;
                    height: 0.5rem;
                    background: url(data:image/png;base64,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);
                    background-size: 100%;
                    background-repeat: no-repeat;
                  "></div>
              </el-icon>
              <div class="el-upload__text">
                <div style="font-size: 0.14rem; color: #333333">
                  上传营业执照
                </div>
              </div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="联系人" prop="contactPerson">
          <el-input v-model="ruleForm.contactPerson" placeholder="请输入联系人" />
        </el-form-item>
        <el-form-item label="公司电话" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入公司电话" />
        </el-form-item>
        <el-form-item label="联系人微信" prop="contactWechat">
          <el-input v-model="ruleForm.contactWechat" placeholder="请输入联系人微信" />
        </el-form-item>
        <el-form-item label="公司官网" prop="webUrl">
          <el-input v-model="ruleForm.webUrl" placeholder="请输入公司官网" />
        </el-form-item>
        <el-form-item label="成立年份" prop="establishedIn">
          <!-- <el-input v-model="ruleForm.establishedIn" placeholder="请选择" /> -->
          <el-date-picker :disabled-date="pickerOptions" v-model="ruleForm.establishedIn" type="year"
            placeholder="请选择入行年份" />
        </el-form-item>
      </el-form>
      <div style="display: flex">
        <div class="dataBtn" @click="onSubmit">提交</div>
      </div>
    </div>
    <!-- 申请成功 -->
    <div style="padding: 1.4rem 0" v-if="show == 'success'">
      <div style="width: 0.48rem; height: 0.48rem; margin: 0 auto">
        <img style="width: 100%; height: 100%" src="@/assets/img/tips／check-circle-fill@2x.png" />
      </div>
      <div style="
          font-size: 0.14rem;
          text-align: center;
          margin-top: 0.16rem;
          margin-bottom: 0.04rem;
          color: #333333;
        ">
        操作成功
      </div>
      <div style="color: #86909c; font-size: 0.14rem; text-align: center">
        等待工作人员审核，预计1-5个工作日
      </div>
    </div>
    <!-- 申请失败 -->
    <div style="padding: 1.4rem 0" v-if="show == 'error'">
      <div style="width: 0.48rem; height: 0.48rem; margin: 0 auto">
        <img style="width: 100%; height: 100%" src="@/assets/img/tips／close-circle-fill@2x.png" />
      </div>
      <div style="
          font-size: 0.14rem;
          text-align: center;
          margin-top: 0.16rem;
          margin-bottom: 0.04rem;
          color: #333333;
        ">
        认证失败
      </div>
      <div style="color: #86909c; font-size: 0.14rem; text-align: center">
        您提交的证明材料不足以证明您的职业
      </div>
      <div class="editBtn" @click="cz">修改信息</div>
    </div>
    <!-- 认证成功 -->
    <div style="padding: 1.4rem 0" v-if="show == 'authentication'">
      <div style="width: 0.48rem; height: 0.48rem; margin: 0 auto">
        <img style="width: 100%; height: 100%" src="@/assets/img/tips／check-circle-fill@2x.png" />
      </div>
      <div style="text-align: center; color: #00b42a">认证已完成</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref } from "vue";
import { Axios } from "@/assets/js/ls_com_axios.js";
import {
  TabsPaneContext,
  FormInstance,
  FormRules,
  ElTable,
  ElMessage,
} from "element-plus";
let show = ref("false");
const pickerOptions = (time) => {
  return time.getFullYear() > new Date().getFullYear();
}
/**
 * upload_showImage上传路径
 * 身份证证件照  给ruleForm.showImage  赋值
 */
import { serverBaseUrl } from "@/assets/js/ls_tgServerUrls.js";
const upload_showImage = ref(serverBaseUrl + "/file/upload");

// 表单
// interface RuleForm {
//   name: string;
//   radio: number;
// }
const formSize = ref("default");
// const ruleFormRef = ref<FormInstance>();
const percentageValue = 30;
const progressValue = (percentage) =>
  percentage === 100 ? "100%" : `${percentage}%`;
// do not use same name with ref
const ruleForm = ref({
  contactPerson: "",
  contactWechat: "",
  districtId: null,
  establishedIn: null,
  industryId: null,
  licenseSrc: "",
  name: "",
  provinceId: null,
  webUrl: "",
  phone: "",
});
const rules = reactive({
  name: [{ required: true, message: "不能为空！", trigger: "change" }],
  provinceId: [{ required: true, message: "不能为空！", trigger: "change" }],
  industryId: [{ required: true, message: "不能为空！", trigger: "change" }],
  licenseSrc: [{ required: true, message: "不能为空！", trigger: "change" }],
  contactPerson: [{ required: true, message: "不能为空！", trigger: "change" }],
  // contactWechat: [{ required: true, message: "不能为空！", trigger: "change" }],
  // webUrl: [{ required: true, message: "不能为空！", trigger: "change" }],
  establishedIn: [{ required: true, message: "不能为空！", trigger: "change" }],
  phone: [{ required: true, message: "不能为空！", trigger: "change" }],
});
const cz = (e: any) => {
  show.value = "false";
  ruleForm.value = {
    contactPerson: "",
    contactWechat: "",
    districtId: null,
    establishedIn: null,
    industryId: null,
    licenseSrc: "",
    name: "",
    provinceId: null,
    webUrl: "",
  };
};
const ruleFormRef = ref();
const loading = ref(false);
const onSubmit = () => {
  ruleFormRef.value.validate((valid: any) => {
    if (valid) {
      let obj = { ...ruleForm.value };
      let pro = ruleForm.value.provinceId[0];
      let dis = ruleForm.value.provinceId[1];
      obj.provinceId = pro;
      obj.districtId = dis;
      let dd = ruleForm.value.establishedIn.getFullYear();
      console.log("----" + dd);
      console.log(dd);
      obj.establishedIn = parseInt(dd); // 提取年份信息
      console.log(obj);
      loading.value = true;
      onSubmitAxios(obj).then(() => {
        loading.value = false;
        ElMessage.success("操作成功");
        // setTimeout(() => {
        //   show.value = "error";
        // }, 1000);
        show.value = "success";
        getInfo();
      });
    } else {
      console.log("error submit!");
      loading.value = false;
      return false;
    }
  });
};
const allowedExtensions = [".png", ".jpg", ".jpeg"];
// 上传前
const upload = ref();
const handleChange = (uploadFile: any, uploadFiles: any) => {
  if (
    allowedExtensions.indexOf(
      uploadFile.name
        .substring(uploadFile.name.lastIndexOf("."))
        .toLocaleLowerCase()
    ) == -1
  ) {
    upload.value.handleRemove(uploadFile, 1);
    ElMessage.warning("格式不正确");
    return;
  }
};
// // 删除图片
const fileList = ref([]);
const handleRemove = (file, fileList1, type) => {
  ruleForm.value.licenseSrc = null;
};
//保存接口
const onSubmitAxios = (obj: any) => {
  //resolve, reject    resolve 成功  reject 失败
  return new Promise((resolve, reject) => {
    Axios("POST", "/member/enterprise-cert", obj, false, function (res: any) {
      if (res.data.code == 200) {
        resolve(res.data);
      } else {
        reject();
      }
    });
  });
};

/**上传 */
const onSuccessFrontSrc = (res: any) => {
  if (res.code == 200) {
    ruleForm.value.licenseSrc = res.data.url;
    ElMessage({
      message: "上传成功",
      type: "success",
    });
  } else {
    ElMessage({
      message: "上传失败",
      type: "error",
    });
  }
};

/**
 * 行业类型请求
 */
const hangyelist = ref([]);
const hangyetypoe = function () {
  let params = {
    memberType: "ENTERPRISE",
  };
  Axios("GET", "/member/type/listby", params, false, function (res: any) {
    hangyelist.value = res.data.data;
  });
};
hangyetypoe();

const props = {
  lazy: true,
  lazyLoad(node: any, resolve: any) {
    const { level, id } = node;
    if (level == 0) {
      areaaxios(resolve, 1, 0);
    } else if (level == 1) {
      areaaxios(resolve, node.data.value, 1);
    }
  },
};

const addresList = ref([] as any);
const areaaxios = (resolve: any, pid: any, level: any) => {
  let params = {
    pid: pid,
  };
  Axios("GET", "/system/district/list-all", params, false, function (res: any) {
    const list: { label: any; value: any; leaf: any }[] = [];
    res.data.data.forEach((element: any) => {
      list.push({
        label: element.districtName,
        value: element.id,
        leaf: level >= 1,
      });
    });
    list.length == 34 ? (addresList.value = list) : "";
    // ruleForm.value.provinceName =list
    resolve(list);
  });
};
const getInfo = () => {
  Axios("get", `/member/login-info`, {}, false, (res) => {
    let data = res.data.data;
    if (data.enterpriseStatus == 0) {
      show.value = "false";
    } else if (data.enterpriseStatus == 1) {
      show.value = "success";
    } else if (data.enterpriseStatus == 2) {
      show.value = "authentication";
    } else {
      show.value = "error";
    }
  });
};
getInfo();
</script>

<style scoped>
.upload-demo {
  width: 1.2rem;
  height: 1.2rem;
}

.dataBtn {
  width: 2.68rem;
  padding: 0.12rem 1.06rem;
  background: #c01a26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  text-align: center;
  font-size: 0.14rem;
  color: #fff;
  cursor: pointer;
}

.page2_head {
  width: 12rem;
  background: #f2f3f5;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  opacity: 1;
  padding: 0.16rem;
  box-sizing: border-box;
  margin-bottom: 0.24rem;
}

/deep/.el-upload-dragger {
  width: 100%;
  height: 100%;
  padding: 0 !important;
  box-sizing: border-box !important;
}

.editBtn {
  width: 0.88rem;
  height: 0.37rem;
  line-height: 0.37rem;
  text-align: center;
  background: #c01a26;
  color: #fff;
  margin: 0 auto;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  margin-top: 0.3rem;
  opacity: 1;
  cursor: pointer;
}

/deep/.el-upload-dragger {
  background: #f5f5f5;
}

/deep/.el-upload__input {
  display: none !important;
}
</style>
